"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * DAPP
 *
 * @example
 *
 * import { names } from "dapp-client"
 *
 * names.DAPP // => "......2ke1.o4"
 */
exports.DAPP = "......2ke1.o4";
/**
 * DAPPHDL
 *
 * @example
 *
 * import { names } from "dapp-client"
 *
 * names.DAPPHDL // => ".1a4cm2ke1.o4"
 */
exports.DAPPHDL = ".1a4cm2ke1.o4";
// Contract names
exports.dappservices = "dappservices";
exports.dappairhodl1 = "dappairhodl1";
exports.ipfsservice1 = "ipfsservice1";
exports.oracleservic = "oracleservic";
exports.cronservices = "cronservices";
//# sourceMappingURL=names.js.map